import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartnerBilling = lazy(() => import("@/pages/partner/PartnerBilling"));

export const Route = createFileRoute("/partner/fakturering")({
  head: () => ({
    meta: [
      { title: "Fakturering & avtal – Partnerportal" },
      { name: "description", content: "Fakturor och avtalsinformation för er som partner." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <PartnerBilling />,
});
